import React from 'react';
import AsyncModalConfirmWithLoading from '@/main/components/shared/asyncModalConfirmWithLoading/asyncModalConfirmWithLoading';
import {
  AnnouncementDetailResponse,
  AnnouncementSearchGridResponse
} from '@/main/models/response/announcementResponse';
import { getTranslateByKey } from '@/main/services/utils';
import { announcementApi } from '@/main/api';
import { toast } from 'react-toastify';
import { RoutesConstants } from '@/main/routes/routesConstants';
import { useNavigate } from 'react-router-dom';

interface Props {
  announcement: AnnouncementSearchGridResponse | AnnouncementDetailResponse;
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export function AnnouncementCopyModal({
  announcement,
  openModal,
  setOpenModal
}: Props) {
  const navigate = useNavigate();

  async function handleConfirm() {
    try {
      const result = await announcementApi.copyAnnouncement(announcement.guid);

      toast.success(
        getTranslateByKey('information.announcementCopyCreatedSuccessfully')
      );

      if (result && result.data.result) {
        navigate(
          `${RoutesConstants.registrationRegisterAnnouncement}?announcementGuid=${result.data.result}`
        );
      }

      setOpenModal(false);
    } catch {}
  }

  return (
    <AsyncModalConfirmWithLoading
      isOpen={openModal}
      setIsOpen={setOpenModal}
      label={`${getTranslateByKey(
        'information.announcementCopyConfirmationModal'
      ).replace('{0}', announcement.name ?? '')}`}
      onConfirm={handleConfirm}
      onCancel={() => setOpenModal(false)}
    />
  );
}
